import { apiFetch } from '../utils/api';
import { VehicleBrand } from './vehicleBrands';

export interface VehicleModel {
  id: string;
  brandId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  brand?: VehicleBrand;
  relatedVariantCount?: number;
}

export interface VehicleModelMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface PaginatedVehicleModelsResponse {
  data: VehicleModel[];
  meta: VehicleModelMeta;
}

interface FetchVehicleModelsParams {
  page?: number;
  limit?: number;
  brandId?: string;
  search?: string;
}

export const fetchVehicleModels = (
  params: FetchVehicleModelsParams = {},
): Promise<PaginatedVehicleModelsResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.brandId) {
    searchParams.set('brandId', params.brandId);
  }

  if (params.search) {
    searchParams.set('search', params.search.trim());
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedVehicleModelsResponse>(
    `/vehicle/models${query ? `?${query}` : ''}`,
  );
};

export const createVehicleModel = (payload: { brandId: string; name: string }) =>
  apiFetch<VehicleModel>('/vehicle/models', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateVehicleModel = (
  id: string,
  payload: Partial<{ brandId: string; name: string }>,
) =>
  apiFetch<VehicleModel>(`/vehicle/models/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const deleteVehicleModel = (id: string) =>
  apiFetch<void>(`/vehicle/models/${id}`, {
    method: 'DELETE',
  });

export const fetchVehicleModel = (id: string) =>
  apiFetch<VehicleModel>(`/vehicle/models/${id}`);
